var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceMouthsmallFilled = function SvgFaceMouthsmallFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.125 12c0-5.445 4.43-9.875 9.875-9.875s9.875 4.43 9.875 9.875-4.43 9.875-9.875 9.875S2.125 17.445 2.125 12Zm8.067-3.19c0 .646-.342 1.17-.765 1.17s-.765-.524-.765-1.17c0-.646.342-1.17.765-1.17s.765.524.765 1.17Zm4.372 1.17c.423 0 .765-.524.765-1.17 0-.646-.342-1.17-.765-1.17-.422 0-.765.524-.765 1.17 0 .646.343 1.17.765 1.17Zm.3 4.116a.5.5 0 0 1 .898.44c-.694 1.412-2.17 2.324-3.762 2.324-1.604 0-3.086-.923-3.774-2.35a.5.5 0 1 1 .9-.434A3.2 3.2 0 0 0 12 15.86c1.213 0 2.338-.693 2.864-1.764Z",
    fill: "#000"
  })));
};
export default SvgFaceMouthsmallFilled;